<div class="mobValWrapper">
  <div id="mobileValidationPopup" class="welcome-popup {{additionalClasses}}">

      <div class="topBlockMobile">
          <div class="topTextMobile">
              Mobile Validation
          </div>
          <div class="imgDivMobile">
              <img src="../../../../../assets/images/poor-2.svg" loading="lazy" />
          </div>
          <div class="botTextMobile">
              We are unable to validate your mobile number as<br> required to advance your loan application.<br><br> Thanks for your interest in iCreditWorks.
          </div>
          <!-- <div *ngIf="isMobile" class="botText">
              Thanks for your interest in iCreditWorks.
          </div> -->
      </div>

      <div class="OKbtnMobile btn btn-size_normal btn-primary a-self-center" (click)="close()">OK</div>
  </div>
</div>
